"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSalesposter = createSalesposter;
var create_tracking_params_1 = require("./create-tracking-params");
var enrich_salesposter_1 = require("./enrich-salesposter");
var is_valid_salesposter_response_1 = require("./is-valid-salesposter-response");
var structure_response_1 = require("./structure-response");
/**
 * Used to parse & pre-process CM salesposter responses with html
 * WARNING: Will throw an error if the response does not contain a valid salesposter
 * @param salesposterResponse json response from CM
 * @param options options adjusting or calculating the tracking parameters
 * @returns the enriched salesposter object + tracking parameters
 * @throws Error if the salesposter response is invalid
 */
function createSalesposter(salesposterResponse, options) {
    if (!(0, is_valid_salesposter_response_1.isValidSalesposterResponse)(salesposterResponse)) {
        if (salesposterResponse &&
            typeof salesposterResponse === 'object' &&
            'status' in salesposterResponse) {
            var salesposterStatus = salesposterResponse === null || salesposterResponse === void 0 ? void 0 : salesposterResponse.status;
            throw new Error("Invalid salesposter response from CM with status: ".concat(salesposterStatus));
        }
        throw new Error('Invalid salesposter response from CM without status');
    }
    var salesposterElem = (0, structure_response_1.structureSalesposterResponse)(salesposterResponse);
    var trackingParams = (0, create_tracking_params_1.createTrackingParams)(salesposterElem, options);
    var enrichedSalesposter = (0, enrich_salesposter_1.enrichSalesposter)({
        searchParams: trackingParams.searchParams,
        returnUrl: trackingParams.returnUrl,
        structuredResponse: salesposterElem,
    });
    return {
        salesposter: enrichedSalesposter,
        data: trackingParams.data,
        pulseOrigin: trackingParams.pulseOrigin,
    };
}
//# sourceMappingURL=create-salesposter.js.map